import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH3, fontSupportMedium } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.MtAccountCollection {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
    padding: ${spacing(10)};
  }

  .MtAccountCollection-heading {
    display: flex;
    flex-direction: column;
    gap: ${spacing(2)};
  }

  .MtAccountCollection-title {
    ${fontH3};
    margin: 0;
    color: ${text_colorTextPrimary};
  }

  .MtAccountCollection-subtitle {
    ${fontSupportMedium};
    margin: 0;
    color: ${text_colorTextSecondary};
  }

  .MtAccountCollection-loading {
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
    padding: ${spacing(6)} 0;
  }

  .MtAccountCollection-loading-text {
    ${fontSupportMedium};
    color: ${text_colorTextSecondary};
  }

  /* The MT iframe host. No border/chrome of our own — MT renders (and auto-sizes)
     its own form inside. The min-height is only a floor so the loading state has
     room; MT sets the iframe's height, so we do not force one. */
  .MtAccountCollection-container {
    min-height: ${spacing(75)};
  }

  .MtAccountCollection-container iframe {
    display: block;
    width: 100%;
    border: 0;
  }

  .MtAccountCollection-actions {
    display: flex;
    justify-content: flex-end;
  }
`
